import axios from 'services/axios';
import { API } from 'services/constants';
import { DashboardBranchChipChange, ChargeBranchChipChange } from '../actions';

const createAction = name => ({
  GET_BRANCH_PENDING: `${name}_GET_BRANCH_PENDING`,
  GET_BRANCH_SUCCESS: `${name}_GET_BRANCH_SUCCESS`,
  GET_BRANCH_FALIED: `${name}_GET_BRANCH_FALIED`
});

export const BRANCH = createAction('BRANCH');

export const GetBranch = () => async (dispatch, getState) => {
  dispatch({ type: BRANCH.GET_BRANCH_PENDING });
  try {
    const { authen, company } = getState();
    const { loginUser } = authen;
    const _companyId = company.select.id;

    const params = {
      companyId: loginUser.role === 'super' ? _companyId : loginUser.companyId
    };

    const result = await axios
      .post(API.POST_BRANCH_FILTER, params, {
        headers: { 'Content-Type': 'application/json' }
      })
      .then(res => res.data)
      .catch(error => Promise.reject(error));

    result.push({
      id: '5d4d1ed884b3965e90707235',
      branchName: 'Sample branch 2'
    });

    result.push({
      id: '5d4d1ed884b3965e90707236',
      branchName: 'Sample branch 3'
    });

    dispatch({
      type: BRANCH.GET_BRANCH_SUCCESS,
      payload: result
    });

    dispatch(DashboardBranchChipChange(result));
    dispatch(ChargeBranchChipChange(result));
  } catch (error) {
    dispatch({
      type: BRANCH.GET_BRANCH_FALIED,
      error
    });
  }
};
